import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export default function Login() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = () => {
    window.location.href = auth.getLoginUrl();
  };

  const handleDevLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await auth.devLogin();
      if (response.success && response.token && response.refreshToken && response.user) {
        // Set auth with real refresh token
        setAuth(response.token, response.refreshToken, response.user);
        navigate('/');
      } else {
        setError('Dev login failed');
      }
    } catch (err) {
      console.error('Dev login error:', err);
      setError(err instanceof Error ? err.message : 'Dev login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-prima-600 rounded-2xl flex items-center justify-center">
            <span className="text-white font-bold text-3xl">P</span>
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Prima Fasteignir
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Skráðu þig inn til að halda áfram
          </p>
        </div>

        {/* Login form */}
        <div className="card p-8">
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg shadow-sm bg-white text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-prima-500 transition-colors"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Skrá inn með Google
          </button>

          {/* Development Login */}
          <div className="mt-4">
            <button
              onClick={handleDevLogin}
              disabled={loading}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-orange-300 rounded-lg shadow-sm bg-orange-50 text-orange-700 font-medium hover:bg-orange-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
              {loading ? 'Hleð...' : 'Dev Login (Test)'}
            </button>
            {error && (
              <p className="mt-2 text-sm text-red-600 text-center">{error}</p>
            )}
          </div>

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">
                  Fyrir söluaðila Prima Fasteignir
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-500">
          Með því að skrá þig inn samþykkir þú{' '}
          <a href="#" className="text-prima-600 hover:underline">
            skilmála
          </a>{' '}
          og{' '}
          <a href="#" className="text-prima-600 hover:underline">
            persónuverndarstefnu
          </a>
        </p>
      </div>
    </div>
  );
}
